// extracted by mini-css-extract-plugin
module.exports = {"Line":"underline-module--Line--2m6QV","Small":"underline-module--Small--14-Jj"};